<template>

	<div>

		<p>Como está a saúde da sua empresa?</p>
		<p>A rotina costuma ser corrida em pequenas empresas e a falta de tempo acaba adiando um momento importantíssimo, que é parar um pouco para pensar no negócio e fazer uma avaliação e reflexão com o objetivo de identificar em que momento a sua empresa está.</p>
		<p>O diagnóstico empresarial é uma ferramenta que, além de servir como referência na tomada de decisões importantes para o crescimento e expansão do negócio, é imprescindível para a sobrevivência das empresas, pois a sua realização permite identificar precocemente problemas graves na gestão do negócio, assim como identificar oportunidades de melhorias, possibilitando que sejam feitos ajustes e correções.</p>
		<p>Faça gratuitamente a versão online resumida do diagnóstico empresarial da Catálise e descubra se sua empresa está saudável. </p>

		<br>

		<div class="text-right">
			<button class="btn btn-success" @click="IniciarTeste">Iniciar teste</button>	
		</div>
		
	</div>
	
</template>

<script>

export default {
	name: "BemVindo",
	methods: {
		IniciarTeste () {
			this.$parent.showDadosCadastrais();
			//this.$parent.showQuestionarios();
		}
	}
}
</script>

<style scoped>

</style>